import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MenuSearchService } from './menu-search.service';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { IconButtonDirective } from '../../../../../shared/directives/icon-button.directive';

@Component({
  selector: 'app-menu-search',
  imports: [FormsModule, IconComponent, IconButtonDirective],
  templateUrl: './menu-search.component.html',
  styleUrl: './menu-search.component.scss',
})
export class MenuSearchComponent {
  public searchService = inject(MenuSearchService);

  public searchInput: string = '';
}
